var _circle, _circle2, _circle3, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F60A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32,
    cy: 32,
    r: 30
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    fill: "#FF717F",
    cx: 50.811,
    cy: 36,
    r: 8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    fill: "#FF717F",
    cx: 13.189,
    cy: 36,
    r: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M44.584 40.279c-8.109 5.656-17.106 5.623-25.168 0-.971-.677-1.846.495-1.188 1.578 2.457 4.047 7.418 7.65 13.771 7.65s11.314-3.604 13.771-7.65c.66-1.083-.215-2.254-1.186-1.578z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#664E27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.525 26.854c-1.859-5.111-4.66-7.669-7.461-7.669s-5.602 2.558-7.459 7.669c-.184.515.773 1.443 1.254.938 1.801-1.901 3.957-2.658 6.205-2.658 2.25 0 4.406.757 6.207 2.658.479.506 1.438-.423 1.254-.938zM50.395 26.854c-1.859-5.111-4.66-7.669-7.461-7.669s-5.602 2.558-7.461 7.669c-.184.515.775 1.443 1.254.938 1.803-1.901 3.957-2.658 6.207-2.658s4.404.757 6.207 2.658c.478.506 1.437-.423 1.254-.938z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F60A);
export default __webpack_public_path__ + "static/media/1f60a.492baae1e797ce0252c34847b51cf48b.svg";
export { ForwardRef as ReactComponent };